import { render, staticRenderFns } from "./phone-number-mpesa.vue?vue&type=template&id=5851c287"
import script from "./phone-number-mpesa.vue?vue&type=script&lang=js"
export * from "./phone-number-mpesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/payments/phone-number-mpesa.vue
// module id = sOOr
// module chunks = 0